/** Způsob zobrazení prvku */
export enum Display {
    initial = "initial",
    inherit = "inherit",
    block = "block",
    flex = "flex",
    inline = "inline",
    inlineBlock = "inline-block",
    inlineFlex = "inline-flex",
}

/**
 * Směr skládání prvků
 * @see https://css-tricks.com/almanac/properties/f/flex-direction/
 * */
export enum FlexDirection {
    initial = "initial",
    inherit = "inherit",
    column = "column",
    columnReverse = "column-reverse",
    row = "row",
    rowReverse = "row-reverse",
}

/**
 * Podíl velikosti rodiče
 * @see https://css-tricks.com/almanac/properties/f/flex-grow/
 * */
export enum FlexGrow {
    initial = "initial",
    inherit = "inherit",
    zero = "zero",
    one = "one",
    two = "two",
    three = "three",
    four = "four",
    five = "five",
    six = "six",
    seven = "seven",
    eight = "eight",
    nine = "nine",
    ten = "ten",
}

/**
 * Smršťování obsahu
 * @see https://css-tricks.com/almanac/properties/f/flex-shrink/
 */
export { FlexGrow as FlexShrink };

/**
 * Zalamování obsahu
 * @see https://css-tricks.com/almanac/properties/f/flex-wrap/
 */
export enum FlexWrap {
    nowrap = "nowrap",
    wrap = "wrap",
    wrapReverse = "wrap-reverse",
    initial = "initial",
    inherit = "inherit",
}

/**
 * Pozicování vůči hlavní ose
 * @see https://css-tricks.com/almanac/properties/j/justify-content/
 * */
export enum JustifyContent {
    initial = "initial",
    inherit = "inherit",
    center = "center",
    flexEnd = "flex-end",
    flexStart = "flex-start",
    spaceAround = "space-around",
    spaceBetween = "space-between",
    spaceEvenly = "space-evenly",
}

/** Velikost odsazení */
export enum SpacingSize {
    auto = "auto",
    none = "none",
    xxs = "xxs",
    xs = "xs",
    s = "s",
    m = "m",
    l = "l",
    xl = "xl",
    xxl = "xxl",
    xxxl = "xxxl",
}

/* Pozicování elementu */
export enum Position {
    static = "static",
    relative = "relative",
    fixed = "fixed",
    absolute = "absolute",
    sticky = "sticky",
}
